<div class="empty">
  <div class="big-av">
    <mat-icon>auto_awesome</mat-icon>
  </div>
  <h1>{{ 'Ask your data anything' | translate }}</h1>
  <p class="sub">{{ 'The AI analyst answers using your LEAP monitoring and IH data, and only what your access allows. Try one of these:' | translate }}</p>
  <div class="prompt-cards">
    @for (prompt of prompts; track trackByIndex($index)) {
      <button type="button" class="pcard"
        (click)="onPromptClick(prompt.label)">
        <span class="pcard-icon"><mat-icon>{{ prompt.icon }}</mat-icon></span>
        {{ prompt.label | translate }}
      </button>
    }
  </div>
</div>
